import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"id":"temas-select","item-text":"nome","item-name":"nome","item-value":"temaId","items":_vm.temas,"label":"Regra","placeholder":"Regra","disabled":_vm.disabled},on:{"change":function($event){return _vm.$emit('onChange')}},model:{value:(_vm.filter.regra),callback:function ($$v) {_vm.$set(_vm.filter, "regra", $$v)},expression:"filter.regra"}},[_c('template',{slot:"no-data"},[_vm._v("\n    Nenhum Tema\n  ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }